var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.textToParse),expression:"textToParse"}],staticClass:"markdown__marked-text"},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }